/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CompaniesShareholdersListParams,
  PaginatedShareholderIdentificationList,
  ShareholderIdentification,
  ShareholderIdentificationCreateUpdateRequest
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Get all shareholders for the owner's company. Paginated.
 * @summary List shareholders
 */
export const companiesShareholdersList = (
    params?: CompaniesShareholdersListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedShareholderIdentificationList>(
      {url: `/api/v1/companies/shareholders/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCompaniesShareholdersListQueryKey = (params?: CompaniesShareholdersListParams,) => {
    return [`/api/v1/companies/shareholders/`, ...(params ? [params]: [])] as const;
    }

    
export const getCompaniesShareholdersListQueryOptions = <TData = Awaited<ReturnType<typeof companiesShareholdersList>>, TError = unknown>(params?: CompaniesShareholdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesShareholdersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompaniesShareholdersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesShareholdersList>>> = ({ signal }) => companiesShareholdersList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companiesShareholdersList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompaniesShareholdersListQueryResult = NonNullable<Awaited<ReturnType<typeof companiesShareholdersList>>>
export type CompaniesShareholdersListQueryError = unknown

/**
 * @summary List shareholders
 */
export const useCompaniesShareholdersList = <TData = Awaited<ReturnType<typeof companiesShareholdersList>>, TError = unknown>(
 params?: CompaniesShareholdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesShareholdersList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompaniesShareholdersListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * ViewSet for Shareholder Identification - owner only, approved companies only.
 * @summary Create shareholder
 */
export const companiesShareholdersCreate = (
    shareholderIdentificationCreateUpdateRequest: ShareholderIdentificationCreateUpdateRequest,
 ) => {
      
      
      return customInstance<ShareholderIdentification>(
      {url: `/api/v1/companies/shareholders/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shareholderIdentificationCreateUpdateRequest
    },
      );
    }
  


export const getCompaniesShareholdersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesShareholdersCreate>>, TError,{data: ShareholderIdentificationCreateUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof companiesShareholdersCreate>>, TError,{data: ShareholderIdentificationCreateUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companiesShareholdersCreate>>, {data: ShareholderIdentificationCreateUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  companiesShareholdersCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesShareholdersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companiesShareholdersCreate>>>
    export type CompaniesShareholdersCreateMutationBody = ShareholderIdentificationCreateUpdateRequest
    export type CompaniesShareholdersCreateMutationError = unknown

    /**
 * @summary Create shareholder
 */
export const useCompaniesShareholdersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesShareholdersCreate>>, TError,{data: ShareholderIdentificationCreateUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof companiesShareholdersCreate>>,
        TError,
        {data: ShareholderIdentificationCreateUpdateRequest},
        TContext
      > => {

      const mutationOptions = getCompaniesShareholdersCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * ViewSet for Shareholder Identification - owner only, approved companies only.
 * @summary Get shareholder
 */
export const companiesShareholdersRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ShareholderIdentification>(
      {url: `/api/v1/companies/shareholders/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getCompaniesShareholdersRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/companies/shareholders/${id}/`] as const;
    }

    
export const getCompaniesShareholdersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companiesShareholdersRetrieve>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesShareholdersRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompaniesShareholdersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesShareholdersRetrieve>>> = ({ signal }) => companiesShareholdersRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companiesShareholdersRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompaniesShareholdersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companiesShareholdersRetrieve>>>
export type CompaniesShareholdersRetrieveQueryError = unknown

/**
 * @summary Get shareholder
 */
export const useCompaniesShareholdersRetrieve = <TData = Awaited<ReturnType<typeof companiesShareholdersRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesShareholdersRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompaniesShareholdersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * ViewSet for Shareholder Identification - owner only, approved companies only.
 * @summary Update shareholder
 */
export const companiesShareholdersUpdate = (
    id: number,
    shareholderIdentificationCreateUpdateRequest: ShareholderIdentificationCreateUpdateRequest,
 ) => {
      
      
      return customInstance<ShareholderIdentification>(
      {url: `/api/v1/companies/shareholders/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: shareholderIdentificationCreateUpdateRequest
    },
      );
    }
  


export const getCompaniesShareholdersUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesShareholdersUpdate>>, TError,{id: number;data: ShareholderIdentificationCreateUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof companiesShareholdersUpdate>>, TError,{id: number;data: ShareholderIdentificationCreateUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companiesShareholdersUpdate>>, {id: number;data: ShareholderIdentificationCreateUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  companiesShareholdersUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesShareholdersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companiesShareholdersUpdate>>>
    export type CompaniesShareholdersUpdateMutationBody = ShareholderIdentificationCreateUpdateRequest
    export type CompaniesShareholdersUpdateMutationError = unknown

    /**
 * @summary Update shareholder
 */
export const useCompaniesShareholdersUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesShareholdersUpdate>>, TError,{id: number;data: ShareholderIdentificationCreateUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof companiesShareholdersUpdate>>,
        TError,
        {id: number;data: ShareholderIdentificationCreateUpdateRequest},
        TContext
      > => {

      const mutationOptions = getCompaniesShareholdersUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * ViewSet for Shareholder Identification - owner only, approved companies only.
 * @summary Delete shareholder
 */
export const companiesShareholdersDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/companies/shareholders/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getCompaniesShareholdersDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesShareholdersDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof companiesShareholdersDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companiesShareholdersDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  companiesShareholdersDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesShareholdersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof companiesShareholdersDestroy>>>
    
    export type CompaniesShareholdersDestroyMutationError = unknown

    /**
 * @summary Delete shareholder
 */
export const useCompaniesShareholdersDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesShareholdersDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof companiesShareholdersDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getCompaniesShareholdersDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    